import { combineReducers } from 'redux';

import { auth } from './auth/reducer';
import { layout } from './layout/reducer';
import { clientTransacoes } from './client/transacoes/reducer';
import { clientDashboard } from './client/dashboard/reducer';
import { clientRecebimentos } from './client/recebimentos/reducer';
import { clientMaquinaVirtual } from './client/maquinaVirtual/reducer';
import { clientSimulador } from './client/simulador/reducer';

export default combineReducers({
	auth,
	layout,
	clientTransacoes,
	clientDashboard,
	clientRecebimentos,
	clientMaquinaVirtual,
	clientSimulador,
});
